import { useEffect, useState } from "react";
import { storage } from "../config/storage";
// import { disconnectSocket } from "../lib/utils/socket";

const useSocket = (socket) => {
  const [isConnected, setIsConnected] = useState(false);
  const [socketError, setSocketError] = useState(null);

  const _connectSocket = () => {
    console.log("Socket connected!", socket.id);
    setIsConnected(true);
    setSocketError(null);
  };

  const _disconnectSocket = () => {
    console.log("Socket disconnected!");
    setIsConnected(false);
  };

  const handleUpdateToken = (data) => {
    const { token, sessionKey } = data;

    if (token && token !== storage.fetchFromLocalStorage.token()) {
      storage.setInLocalStorage.token(token);
    }

    if (sessionKey && sessionKey !== storage.fetchFromSessionStorage.sessionKey()) {
      storage.setInSessionStorage.sessionKey(sessionKey);
    }
  };

  const handleError = (error) => {
    console.log("LOCAL, Socket Error:", error);
    setSocketError(error);
  };

  const handleConnectError = (error) => {
    console.log("Connection error:", error?.message);
    setSocketError(error?.message || "Socket connection error");
  };

  useEffect(() => {
    if(!socket) return;

    socket.connect();
    console.log("Connecting socket...");

    // Connect socket
    socket.on("connect", _connectSocket);
    socket.on("disconnect", _disconnectSocket);
    socket.on("update_token", handleUpdateToken);
    socket.on("error", handleError);
    socket.on("connect_error", handleConnectError); // Fallback for network or server errors


    // Cleanup on unmount
    return () => {
      console.log("Disconnecting socket...");

      socket.off("connect", _connectSocket);
      socket.off("disconnect", _disconnectSocket);
      socket.off("update_token", handleUpdateToken);
      socket.off("error", handleError);
      socket.off("connect_error", handleConnectError);
      socket.disconnect();
    };
  }, [socket]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (socket && isConnected && !socket.connected) {
        console.warn("Socket mismatch detected – updating state.");
        setIsConnected(false);
      }
    }, 10000);

    return () => clearInterval(interval);
  }, [socket, isConnected]);

  return { isConnected, socketError };
};

export default useSocket;
